'use client'
import React from 'react'
import { FaChevronRight } from "react-icons/fa";
import { usePathname, useSearchParams } from 'next/navigation'
import style from './breadcrumb.module.scss'
import LocalizedLinkClient from "../LocalizedLink/LocalizedLinkClient";

const NextBreadcrumb = ({locale}) => {
    const paths = usePathname()
    let path = paths
    const localeFromPath = paths?.split('/').filter(Boolean)?.[0]
    const resolvedLocale = locale || localeFromPath || 'en-GB'
    path = path.replace(`/${resolvedLocale}/`, "")
    if (paths?.startsWith('/mijn-mkg/support/kenniscentrum/id/')) {
        path = paths.split("/mijn-mkg/support/kenniscentrum/id/").pop()
        path = '/mijn-mkg/support/kenniscentrum/' + path.split('/').pop()
    }

    if (paths?.startsWith('/mijn-mkg/support/storingen/')) {
        path = paths.split("/mijn-mkg/support/storingen/").pop()
        path = '/mijn-mkg/support/storingen/' + path.split('/').pop()
    }

    if (paths?.startsWith('/mijn-mkg/academy/')) {
        path = paths.split("/mijn-mkg/academy/").pop()
        path = '/mijn-mkg/academy/' + path.split('/').pop()
    }
    const searchParams = useSearchParams()
    const pathNames = path.split('/').filter( path => path )
    const capitalizeLinks = true

    const params = new URLSearchParams(searchParams);

    return (
        <div>
            <ul className={style.containerClasses}>
                {
                    pathNames.map( (link, index, array) => {
                        let href = `/${pathNames.slice(0, index + 1).join('/')}`
                        const itemLink = capitalizeLinks ? link[0].toUpperCase() + link.slice(1, link.length) : link
                        href = href.replace(`/${resolvedLocale}/`, "")
                        //Append searchParams to last breadcrumb url
                        if(index === array.length - 1){
                            href = href + `?${params.toString()}`
                        }
                        if (href === '/mijn-mkg') {
                            href = '/mijn-mkg/dashboard'
                        }
                        return (
                            <React.Fragment key={href}>
                                <li className={style.crumb} >
                                    <LocalizedLinkClient href={href}>{itemLink}</LocalizedLinkClient>
                                </li>
                                {pathNames.length !== index + 1 && (
                                    <li aria-hidden="true" className={style.crumb}>
                                        <FaChevronRight style={{fontSize: '12px'}}/>
                                    </li>
                                )}
                            </React.Fragment>
                        )
                    })
                }
            </ul>
        </div>
    )
}
export default NextBreadcrumb
